import { createReducer, on } from '@ngrx/store';

import { StateUtils } from '@state/state-utils';
import * as VehicleActions from './vehicle.actions';
import { VehicleState, initialVehicleState } from './vehicle.state';

const vehicleReducer = createReducer<VehicleState>(
  initialVehicleState,

  on(VehicleActions.fetchVehicles, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(VehicleActions.fetchVehicleById, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(VehicleActions.fetchVehicleEvents, (state) => ({
    ...state,
    eventsFetchedAt: null,
  })),

  on(VehicleActions.fetchVehiclesSuccess, (state, { vehicles }) => ({
    ...state,
    fetchedAt: new Date(),
    vehicles: StateUtils.combineStateArr(state.vehicles, vehicles),
  })),
  on(VehicleActions.fetchVehiclesFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  })),
  on(
    VehicleActions.fetchVehicleByIdSuccess,
    VehicleActions.assignUserToVehicleSuccess,
    VehicleActions.removeUserFromVehicleSuccess,
    (state, { vehicle }) => ({
      ...state,
      fetchedAt: new Date(),
      vehicles: StateUtils.combineState(state.vehicles, vehicle),
    })
  ),
  on(VehicleActions.fetchVehicleByIdFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  })),
  on(VehicleActions.fetchVehicleEventsSuccess, (state, { vehicleEvents }) => ({
    ...state,
    vehicleEvents: vehicleEvents,
    eventsFetchedAt: new Date(),
  })),

  on(VehicleActions.fetchVehicleBatchByIdSuccess, (state, { batch }) => ({
    ...state,
    batches: StateUtils.combineState(state.batches, batch),
    batchesFetchedAt: new Date(),
  })),
  on(VehicleActions.fetchVehicleBatchesSuccess, (state, { batches }) => ({
    ...state,
    batches,
    batchesFetchedAt: new Date(),
  })),
  on(VehicleActions.createVehicleBatchSuccess, (state, { batch }) => ({
    ...state,
    batches: StateUtils.combineState(state.batches, batch),
  })),
  on(
    VehicleActions.fetchCurrentVehicleInsuranceSuccess,
    (state, { vehicleInsurance, vehicleId }) => ({
      ...state,
      vehicleInsurances: StateUtils.combineState(
        state.vehicleInsurances,
        vehicleInsurance
      ),
      vehicleInsurancesFetchedAt: {
        ...state.vehicleInsurancesFetchedAt,
        [vehicleId]: new Date(),
      },
    })
  ),
  on(
    VehicleActions.fetchCurrentVehicleInsuranceFailed,
    (state, { vehicleId }) => ({
      ...state,
      vehicleInsurancesFetchedAt: {
        ...state.vehicleInsurancesFetchedAt,
        [vehicleId]: new Date(),
      },
    })
  )
);

export { vehicleReducer };
